import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vShow as _vShow } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-contents" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "clearfix" };
const _hoisted_5 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_6 = { class: "input-group top_search" };
const _hoisted_7 = { class: "input-group-btn" };
const _hoisted_8 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_9 = {
    key: 0,
    class: "btn-group pw100"
};
const _hoisted_10 = {
    key: 1,
    class: "row left-10 right-10"
};
const _hoisted_11 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_12 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_13 = { class: "clearfix top10" };
const _hoisted_14 = { class: "col-xs-12 col-sm-6 col-md-3 bottom10" };
const _hoisted_15 = ["disabled"];
const _hoisted_16 = ["value"];
const _hoisted_17 = { class: "col-xs-12 col-sm-6 col-md-3 bottom10" };
const _hoisted_18 = ["disabled"];
const _hoisted_19 = ["value"];
const _hoisted_20 = { class: "col-xs-12 col-sm-6 col-md-3 bottom10" };
const _hoisted_21 = ["disabled"];
const _hoisted_22 = ["value"];
const _hoisted_23 = { class: "col-xs-12 col-sm-6 col-md-3 bottom10" };
const _hoisted_24 = ["disabled"];
const _hoisted_25 = ["value"];
const _hoisted_26 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-12"
};
const _hoisted_27 = { class: "clearfix data-grid-top-pagination" };
const _hoisted_28 = { class: "float-end" };
const _hoisted_29 = { class: "float-end hidden-xs record-count" };
const _hoisted_30 = { class: "float-start" };
const _hoisted_31 = { class: "col-xs-12 col-sm-12" };
const _hoisted_32 = { class: "card bg-white data-grid audit-log-grid detached overflow-x-auto" };
const _hoisted_33 = {
    id: "auditLogTable",
    class: "table table-hover border-collapse-separate bottom0"
};
const _hoisted_34 = { class: "date-time-column" };
const _hoisted_35 = { class: "hidden-sm" };
const _hoisted_36 = { class: "hidden-sm" };
const _hoisted_37 = ["onClick"];
const _hoisted_38 = ["title"];
const _hoisted_39 = ["title"];
const _hoisted_40 = {
    key: 0,
    class: "text-muted font11"
};
const _hoisted_41 = ["title"];
const _hoisted_42 = { class: "text-muted font11 visible-sm" };
const _hoisted_43 = { class: "hidden-sm" };
const _hoisted_44 = { class: "hidden-sm" };
const _hoisted_45 = {
    key: 0,
    class: "audit-log-detail-row"
};
const _hoisted_46 = { colspan: "5" };
const _hoisted_47 = {
    key: 0,
    class: "p-2"
};
const _hoisted_48 = {
    key: 1,
    class: "table table-sm bottom0"
};
const _hoisted_49 = ["title"];
const _hoisted_50 = {
    key: 0,
    colspan: "2",
    class: "text-muted fst-italic"
};
const _hoisted_51 = ["title"];
const _hoisted_52 = { key: 0 };
const _hoisted_53 = {
    key: 1,
    class: "text-muted fst-italic"
};
const _hoisted_54 = ["title"];
const _hoisted_55 = { key: 0 };
const _hoisted_56 = {
    key: 1,
    class: "text-muted fst-italic"
};
const _hoisted_57 = {
    key: 2,
    class: "p-2 text-muted"
};
const _hoisted_58 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_button = _resolveComponent("b-button");
    const _component_flat_pickr = _resolveComponent("flat-pickr");
    const _component_b_input_group_append = _resolveComponent("b-input-group-append");
    const _component_b_input_group = _resolveComponent("b-input-group");
    const _component_b_pagination = _resolveComponent("b-pagination");
    const _component_SortableColumnComponent = _resolveComponent("SortableColumnComponent");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[70] || (_cache[70] = _createElementVNode("div", { class: "form-details" }, [
            _createElementVNode("div", { class: "form-title" }, [
                _createElementVNode("h2", null, "\r\n\t\t\t\t\tAudit Log\r\n\t\t\t\t")
            ])
        ], -1 /* CACHED */)),
        _cache[71] || (_cache[71] = _createTextVNode()),
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_b_form_input, {
                                type: "text",
                                modelValue: _ctx.query.keywords,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.query.keywords) = $event)),
                                modelModifiers: { trim: true },
                                placeholder: "Search for...",
                                onKeyup: _withKeys(_ctx.search, ["enter"])
                            }, null, 8 /* PROPS */, ["modelValue", "onKeyup"]),
                            _cache[15] || (_cache[15] = _createTextVNode()),
                            _createElementVNode("span", _hoisted_7, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-default",
                                    onClick: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_ctx.search && _ctx.search(...args)))
                                }, [...(_cache[14] || (_cache[14] = [
                                        _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* CACHED */)
                                    ]))])
                            ])
                        ])
                    ]),
                    _cache[23] || (_cache[23] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_8, [
                        (!_ctx.showDatePickers)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateFilterOptions, (item, idx) => {
                                    return (_openBlock(), _createBlock(_component_b_button, {
                                        class: "pw100",
                                        disabled: _ctx.working,
                                        key: idx,
                                        variant: _ctx.dateFilterOption == item ? 'primary' : 'outline-secondary',
                                        onClick: ($event) => (_ctx.setDateFilterOption(item))
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(item), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["disabled", "variant", "onClick"]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]))
                            : _createCommentVNode("v-if", true),
                        _cache[22] || (_cache[22] = _createTextVNode()),
                        (_ctx.showDatePickers)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                    _createVNode(_component_b_input_group, { class: "top_search" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_flat_pickr, {
                                                class: "form-control",
                                                modelValue: _ctx.startTime,
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.startTime) = $event)),
                                                config: _ctx.datePickerConfig,
                                                placeholder: "From date",
                                                disabled: _ctx.working
                                            }, null, 8 /* PROPS */, ["modelValue", "config", "disabled"]),
                                            _cache[17] || (_cache[17] = _createTextVNode()),
                                            _createVNode(_component_b_input_group_append, { class: "input-group-btn" }, {
                                                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                                        _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
                                                            _createElementVNode("button", {
                                                                type: "button",
                                                                class: "btn btn-default",
                                                                "data-toggle": ""
                                                            }, [
                                                                _createElementVNode("i", { class: "fa fa-calendar" })
                                                            ])
                                                        ], -1 /* CACHED */)
                                                    ]))]),
                                                _: 1 /* STABLE */
                                            })
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _cache[21] || (_cache[21] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_12, [
                                    _createVNode(_component_b_input_group, { class: "top_search" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_flat_pickr, {
                                                class: "form-control",
                                                modelValue: _ctx.endTime,
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.endTime) = $event)),
                                                config: _ctx.datePickerConfig,
                                                placeholder: "Until date",
                                                disabled: _ctx.working
                                            }, null, 8 /* PROPS */, ["modelValue", "config", "disabled"]),
                                            _cache[20] || (_cache[20] = _createTextVNode()),
                                            _createVNode(_component_b_input_group_append, { class: "input-group-btn" }, {
                                                default: _withCtx(() => [
                                                    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
                                                        _createElementVNode("button", {
                                                            type: "button",
                                                            class: "btn btn-default",
                                                            "data-toggle": ""
                                                        }, [
                                                            _createElementVNode("i", { class: "fa fa-calendar" })
                                                        ])
                                                    ], -1 /* CACHED */)),
                                                    _cache[19] || (_cache[19] = _createTextVNode()),
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: "btn btn-secondary",
                                                        onClick: _cache[4] || (_cache[4] =
                                                            //@ts-ignore
                                                            (...args) => (_ctx.resetDateFilterOption && _ctx.resetDateFilterOption(...args)))
                                                    }, "\r\n\t\t\t\t\t\t\t\t\t\t\t...\r\n\t\t\t\t\t\t\t\t\t\t")
                                                ]),
                                                _: 1 /* STABLE */
                                            })
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ])
                ]),
                _cache[65] || (_cache[65] = _createTextVNode()),
                _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                        _cache[26] || (_cache[26] = _createElementVNode("label", null, "Who", -1 /* CACHED */)),
                        _cache[27] || (_cache[27] = _createTextVNode()),
                        _withDirectives(_createElementVNode("select", {
                            class: "form-select",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.query.actorUserId) = $event)),
                            disabled: _ctx.working,
                            onChange: _cache[6] || (_cache[6] =
                                //@ts-ignore
                                (...args) => (_ctx.search && _ctx.search(...args)))
                        }, [
                            _cache[24] || (_cache[24] = _createElementVNode("option", { value: null }, "Anyone", -1 /* CACHED */)),
                            _cache[25] || (_cache[25] = _createTextVNode()),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterOptions.actors, (actor) => {
                                return (_openBlock(), _createElementBlock("option", {
                                    key: actor.value,
                                    value: Number(actor.value)
                                }, _toDisplayString(actor.label), 9 /* TEXT, PROPS */, _hoisted_16));
                            }), 128 /* KEYED_FRAGMENT */))
                        ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_15), [
                            [_vModelSelect, _ctx.query.actorUserId]
                        ])
                    ]),
                    _cache[40] || (_cache[40] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_17, [
                        _cache[30] || (_cache[30] = _createElementVNode("label", null, "Did what", -1 /* CACHED */)),
                        _cache[31] || (_cache[31] = _createTextVNode()),
                        _withDirectives(_createElementVNode("select", {
                            class: "form-select",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.query.action) = $event)),
                            disabled: _ctx.working,
                            onChange: _cache[8] || (_cache[8] =
                                //@ts-ignore
                                (...args) => (_ctx.search && _ctx.search(...args)))
                        }, [
                            _cache[28] || (_cache[28] = _createElementVNode("option", { value: null }, "Anything", -1 /* CACHED */)),
                            _cache[29] || (_cache[29] = _createTextVNode()),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterOptions.actions, (action) => {
                                return (_openBlock(), _createElementBlock("option", {
                                    key: action.value,
                                    value: Number(action.value)
                                }, _toDisplayString(action.label), 9 /* TEXT, PROPS */, _hoisted_19));
                            }), 128 /* KEYED_FRAGMENT */))
                        ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_18), [
                            [_vModelSelect, _ctx.query.action]
                        ])
                    ]),
                    _cache[41] || (_cache[41] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_20, [
                        _cache[34] || (_cache[34] = _createElementVNode("label", null, "Area", -1 /* CACHED */)),
                        _cache[35] || (_cache[35] = _createTextVNode()),
                        _withDirectives(_createElementVNode("select", {
                            class: "form-select",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.query.entityArea) = $event)),
                            disabled: _ctx.working,
                            onChange: _cache[10] || (_cache[10] =
                                //@ts-ignore
                                (...args) => (_ctx.search && _ctx.search(...args)))
                        }, [
                            _cache[32] || (_cache[32] = _createElementVNode("option", { value: null }, "All areas", -1 /* CACHED */)),
                            _cache[33] || (_cache[33] = _createTextVNode()),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterOptions.areas, (area) => {
                                return (_openBlock(), _createElementBlock("option", {
                                    key: area.value,
                                    value: Number(area.value)
                                }, _toDisplayString(area.label), 9 /* TEXT, PROPS */, _hoisted_22));
                            }), 128 /* KEYED_FRAGMENT */))
                        ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_21), [
                            [_vModelSelect, _ctx.query.entityArea]
                        ])
                    ]),
                    _cache[42] || (_cache[42] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_23, [
                        _cache[38] || (_cache[38] = _createElementVNode("label", null, "Record type", -1 /* CACHED */)),
                        _cache[39] || (_cache[39] = _createTextVNode()),
                        _withDirectives(_createElementVNode("select", {
                            class: "form-select",
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.query.entityType) = $event)),
                            disabled: _ctx.working,
                            onChange: _cache[12] || (_cache[12] =
                                //@ts-ignore
                                (...args) => (_ctx.search && _ctx.search(...args)))
                        }, [
                            _cache[36] || (_cache[36] = _createElementVNode("option", { value: null }, "All record types", -1 /* CACHED */)),
                            _cache[37] || (_cache[37] = _createTextVNode()),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterOptions.entityTypes, (entityType) => {
                                return (_openBlock(), _createElementBlock("option", {
                                    key: entityType.value,
                                    value: entityType.value
                                }, _toDisplayString(entityType.label), 9 /* TEXT, PROPS */, _hoisted_25));
                            }), 128 /* KEYED_FRAGMENT */))
                        ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_24), [
                            [_vModelSelect, _ctx.query.entityType]
                        ])
                    ])
                ]),
                _cache[66] || (_cache[66] = _createTextVNode()),
                _cache[67] || (_cache[67] = _createElementVNode("div", { class: "clearfix" }, null, -1 /* CACHED */)),
                _cache[68] || (_cache[68] = _createTextVNode()),
                (_ctx.searchAttempted)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                                _createVNode(_component_b_pagination, {
                                    class: "float-end",
                                    modelValue: _ctx.query.page,
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.query.page) = $event)),
                                    "per-page": _ctx.query.pageSize,
                                    "total-rows": _ctx.data.recordCount,
                                    "hide-ellipsis": true,
                                    disabled: _ctx.working
                                }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                            ]),
                            _cache[44] || (_cache[44] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_29, "\r\n\t\t\t\t\t\t\tItems: " + _toDisplayString(_ctx.data.recordCount), 1 /* TEXT */),
                            _cache[45] || (_cache[45] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_30, [
                                _createVNode(_component_b_button, {
                                    variant: "outline-secondary",
                                    disabled: _ctx.working || _ctx.exporting || _ctx.data.recordCount === 0,
                                    onClick: _ctx.exportCsv
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("i", {
                                            class: _normalizeClass(["fa", _ctx.exporting ? 'fa-spinner fa-spin' : 'fa-download'])
                                        }, null, 2 /* CLASS */),
                                        _cache[43] || (_cache[43] = _createTextVNode("\r\n\t\t\t\t\t\t\t\tExport CSV\r\n\t\t\t\t\t\t\t", -1 /* CACHED */))
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["disabled", "onClick"])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("v-if", true),
                _cache[69] || (_cache[69] = _createTextVNode()),
                _withDirectives(_createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("table", _hoisted_33, [
                            _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", _hoisted_34, [
                                        _createVNode(_component_SortableColumnComponent, {
                                            sorter: _ctx.sorter,
                                            column: { fieldName: 'WhenCreated', title: 'When', visible: true }
                                        }, null, 8 /* PROPS */, ["sorter"])
                                    ]),
                                    _cache[46] || (_cache[46] = _createTextVNode()),
                                    _createElementVNode("th", _hoisted_35, [
                                        _createVNode(_component_SortableColumnComponent, {
                                            sorter: _ctx.sorter,
                                            column: { fieldName: 'ActorName', title: 'Who' }
                                        }, null, 8 /* PROPS */, ["sorter"])
                                    ]),
                                    _cache[47] || (_cache[47] = _createTextVNode()),
                                    _cache[48] || (_cache[48] = _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\tWhat happened\r\n\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                    _cache[49] || (_cache[49] = _createTextVNode()),
                                    _createElementVNode("th", _hoisted_36, [
                                        _createVNode(_component_SortableColumnComponent, {
                                            sorter: _ctx.sorter,
                                            column: { fieldName: 'EntityArea', title: 'Area' }
                                        }, null, 8 /* PROPS */, ["sorter"])
                                    ]),
                                    _cache[50] || (_cache[50] = _createTextVNode()),
                                    _cache[51] || (_cache[51] = _createElementVNode("th", { class: "hidden-sm" }, "\r\n\t\t\t\t\t\t\t\t\t\tSource\r\n\t\t\t\t\t\t\t\t\t", -1 /* CACHED */))
                                ])
                            ]),
                            _cache[63] || (_cache[63] = _createTextVNode()),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, {
                                        key: item.activityAuditId
                                    }, [
                                        _createElementVNode("tr", {
                                            class: "pointer",
                                            onClick: ($event) => (_ctx.toggleDetails(item))
                                        }, [
                                            _createElementVNode("td", null, [
                                                _createElementVNode("span", {
                                                    title: _ctx.formatUtc(item.whenCreated)
                                                }, _toDisplayString(_ctx.formatTimeString(item.whenCreated)), 9 /* TEXT, PROPS */, _hoisted_38)
                                            ]),
                                            _cache[52] || (_cache[52] = _createTextVNode()),
                                            _createElementVNode("td", {
                                                class: "hidden-sm large-text-ellipsis",
                                                title: item.actorName
                                            }, [
                                                _createTextVNode(_toDisplayString(item.actorName) + " ", 1 /* TEXT */),
                                                (item.actorRole)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(item.actorRole), 1 /* TEXT */))
                                                    : _createCommentVNode("v-if", true)
                                            ], 8 /* PROPS */, _hoisted_39),
                                            _cache[53] || (_cache[53] = _createTextVNode()),
                                            _createElementVNode("td", {
                                                class: "audit-log-description",
                                                title: item.description
                                            }, [
                                                (item.detailCount > 0)
                                                    ? (_openBlock(), _createElementBlock("i", {
                                                        key: 0,
                                                        class: _normalizeClass(["fa font11 me-1", _ctx.isExpanded(item) ? 'fa-chevron-down' : 'fa-chevron-right'])
                                                    }, null, 2 /* CLASS */))
                                                    : _createCommentVNode("v-if", true),
                                                _createTextVNode(" " + _toDisplayString(item.description) + " ", 1 /* TEXT */),
                                                _createElementVNode("div", _hoisted_42, _toDisplayString(item.actorName), 1 /* TEXT */)
                                            ], 8 /* PROPS */, _hoisted_41),
                                            _cache[54] || (_cache[54] = _createTextVNode()),
                                            _createElementVNode("td", _hoisted_43, _toDisplayString(item.entityAreaDescription), 1 /* TEXT */),
                                            _cache[55] || (_cache[55] = _createTextVNode()),
                                            _createElementVNode("td", _hoisted_44, _toDisplayString(item.sourceDescription), 1 /* TEXT */)
                                        ], 8 /* PROPS */, _hoisted_37),
                                        _cache[61] || (_cache[61] = _createTextVNode()),
                                        (_ctx.isExpanded(item))
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_45, [
                                                _createElementVNode("td", _hoisted_46, [
                                                    (_ctx.loadingDetailsFor === item.activityAuditId)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_47, [...(_cache[56] || (_cache[56] = [
                                                                _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                                                                _createTextVNode(" Loading changes...\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                            ]))]))
                                                        : (_ctx.expandedDetails.length > 0)
                                                            ? (_openBlock(), _createElementBlock("table", _hoisted_48, [
                                                                _cache[59] || (_cache[59] = _createElementVNode("thead", null, [
                                                                    _createElementVNode("tr", null, [
                                                                        _createElementVNode("th", null, "Field"),
                                                                        _createTextVNode(),
                                                                        _createElementVNode("th", null, "Before"),
                                                                        _createTextVNode(),
                                                                        _createElementVNode("th", null, "After")
                                                                    ])
                                                                ], -1 /* CACHED */)),
                                                                _cache[60] || (_cache[60] = _createTextVNode()),
                                                                _createElementVNode("tbody", null, [
                                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expandedDetails, (detail) => {
                                                                        return (_openBlock(), _createElementBlock("tr", {
                                                                            key: detail.activityAuditDetailId
                                                                        }, [
                                                                            _createElementVNode("td", {
                                                                                title: detail.fieldLabel
                                                                            }, _toDisplayString(detail.fieldLabel), 9 /* TEXT, PROPS */, _hoisted_49),
                                                                            _cache[58] || (_cache[58] = _createTextVNode()),
                                                                            (detail.isSensitive)
                                                                                ? (_openBlock(), _createElementBlock("td", _hoisted_50, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tvalue changed\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"))
                                                                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                                    _createElementVNode("td", {
                                                                                        class: "large-text-ellipsis",
                                                                                        title: detail.oldValue
                                                                                    }, [
                                                                                        (detail.oldValue)
                                                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(detail.oldValue), 1 /* TEXT */))
                                                                                            : (_openBlock(), _createElementBlock("span", _hoisted_53, "empty"))
                                                                                    ], 8 /* PROPS */, _hoisted_51),
                                                                                    _cache[57] || (_cache[57] = _createTextVNode()),
                                                                                    _createElementVNode("td", {
                                                                                        class: "large-text-ellipsis",
                                                                                        title: detail.newValue
                                                                                    }, [
                                                                                        (detail.newValue)
                                                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString(detail.newValue), 1 /* TEXT */))
                                                                                            : (_openBlock(), _createElementBlock("span", _hoisted_56, "empty"))
                                                                                    ], 8 /* PROPS */, _hoisted_54)
                                                                                ], 64 /* STABLE_FRAGMENT */))
                                                                        ]));
                                                                    }), 128 /* KEYED_FRAGMENT */))
                                                                ])
                                                            ]))
                                                            : (_openBlock(), _createElementBlock("div", _hoisted_57, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tNo field-level changes were recorded for this entry.\r\n\t\t\t\t\t\t\t\t\t\t\t"))
                                                ])
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ], 64 /* STABLE_FRAGMENT */));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _cache[64] || (_cache[64] = _createTextVNode()),
                            _createElementVNode("tfoot", null, [
                                (_ctx.noData)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_58, [...(_cache[62] || (_cache[62] = [
                                            _createElementVNode("td", {
                                                class: "text-center",
                                                colspan: "5"
                                            }, [
                                                _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t")
                                            ], -1 /* CACHED */)
                                        ]))]))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ])
                ], 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.searchAttempted]
                ])
            ])
        ])
    ]));
}
